import {openPacketCaptureSection} from '../apSections/adapter';

/**
 * Canvas Access Point dashboard > Packet Capture.
 *
 * An accordion inside one Access Point, so the context is `ap` and the
 * workflow asks which Access Point when the request did not name one. The
 * page reports when the accordion is actually showing, which is what makes
 * this verified rather than merely registered.
 */
const packetCapturePlugin = {
	id: 'packet_capture',
	version: 1,
	commandVersion: 1,
	resource: 'packet_capture',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['ap.dashboard'],
	},
	sections: {
		'ap.packet_capture': openPacketCaptureSection,
	},
};

export default packetCapturePlugin;
